import { render, staticRenderFns } from "./approvalList.vue?vue&type=template&id=84968542&scoped=true&"
import script from "./approvalList.vue?vue&type=script&lang=js&"
export * from "./approvalList.vue?vue&type=script&lang=js&"
import style0 from "./approvalList.vue?vue&type=style&index=0&id=84968542&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84968542",
  null
  
)

component.options.__file = "approvalList.vue"
export default component.exports